import jMoment from 'moment-jalaali';
import WITHDRAW_TYPES from '../../constants/ruleTypes';
import { PriceLabel } from 'components';


export const VOUCHER_TYPES = {
  1: 'شارژ اعتبار',
  2: 'تخفیف مبلغی',
  4: 'تخفیف درصدی - یکبار مصرف برای یک آیتم',
  8: 'تخفیف درصدی - بدون محدودیت',
  16: 'تخفیف درصدی - یکبار مصرف برای یک فاکتور',
};

export const FILTER_VOUCHER_TYPES = {
  2: 'تخفیف مبلغی',
  4: 'تخفیف درصدی - یکبار مصرف برای یک آیتم',
  8: 'تخفیف درصدی - بدون محدودیت',
  16: 'تخفیف درصدی - یک بار مصرف برای یک فاکتور',
};

const columns = (currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'شناسه مجوز',
    field: 'id',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },

  {
    title: 'نوع مجوز',
    field: 'typeCode',
    filtering: false,
    sorting: false,
    render: (rd) =>
      rd?.typeCode ? WITHDRAW_TYPES.find((v) => v?.value === rd.typeCode)?.label ?? '-' : '-',
  },
  {
    title: 'تاریخ ایجاد',
    field: 'creationDate',
    filtering: false,
    sorting: false,
    render: (rc) => jMoment(rc?.creationDate).format('dddd, jD jMMMM jYYYY'),
    cellStyle: {
      width: '20%',
    },
    headerStyle: {
      width: '20%',
    },
  },
  {
    title: 'مدت اشتراک - روز',
    field: 'subscriptionDaysAmount',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) =>
       <PriceLabel amount={rd.subscriptionDaysAmount} />,
    cellStyle: {
      width: '10%',
    },
    headerStyle: {
      width: '10%',
    },
  },
  {
    title: `سقف قابل برداشت - ${currencyText}`,
    field: 'maxAmount',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => ( <PriceLabel amount={rd.maxAmount} />),
    cellStyle: {
      width: '10%',
    },
    headerStyle: {
      width: '10%',
    },
  },
  {
    title: 'سقف دفعات برداشت',
    field: 'maxCount',
    filtering: false,
    sorting: false,
    align: 'center',
    render: (rd) => ( <PriceLabel amount={rd.maxCount} />),
    cellStyle: {
      width: '10%',
    },
    headerStyle: {
      width: '10%',
    },
  },

];

const columnsId = {};

const orderingIndexes = [
  null,
  'زمان شروع',
  'زمان انقضا',
  'نام و نام خانوادگی',
  'میزان',
  'استفاده شده',
  'تعداد شارژ مجدد',
  'وضعیت',
  null,
  null,
  null,
];

const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, columnsId, generateData, orderingIndexes };
